/* Edge — move between prints: swipe the photo on a phone, arrow keys or (Prev)/(Next) on desktop */
(function () {
  var nav = document.querySelector('[data-nav]');
  if (!nav) return;
  var prevUrl = nav.getAttribute('data-prev'), nextUrl = nav.getAttribute('data-next');
  var stage = document.querySelector('.pdp__stage');
  var img = stage && stage.querySelector('.pdp__img');
  var KEY = 'edge-carry';

  // keep the buyer's format and size when they move to the next print
  var carry = function () {
    try {
      var sel = Array.prototype.map.call(document.querySelectorAll('[data-opt][aria-pressed="true"]'), function (b) { return b.getAttribute('data-val'); });
      sessionStorage.setItem(KEY, JSON.stringify(sel));
    } catch (e) {}
  };
  var go = function (dir, swiped) {
    var url = dir === 'next' ? nextUrl : prevUrl;
    if (!url) return;
    carry();
    if (swiped && img) {
      img.style.transition = 'transform 220ms cubic-bezier(.4,0,.2,1), opacity 220ms ease';
      img.style.transform = 'translateX(' + (dir === 'next' ? -1 : 1) * window.innerWidth * 0.6 + 'px)';
      img.style.opacity = '0';
      setTimeout(function () { location.href = url; }, 190);
    } else {
      location.href = url;
    }
  };

  // (Prev) / (Next) links carry the selection too
  Array.prototype.forEach.call(nav.querySelectorAll('a'), function (a) {
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      go(a.hasAttribute('data-nav-next') ? 'next' : 'prev');
    });
  });

  // arrow keys (not while typing, not while the full-screen view is open)
  document.addEventListener('keydown', function (e) {
    if (e.altKey || e.metaKey || e.ctrlKey) return;
    if (e.target.closest && e.target.closest('input, textarea, select')) return;
    if (document.querySelector('.zoom')) return;
    if (e.key === 'ArrowRight') go('next');
    if (e.key === 'ArrowLeft') go('prev');
  });

  // swipe: the photo follows the finger, past the threshold it slides away and the next print loads
  if (img && img.tagName === 'IMG') {
    var sx = 0, sy = 0, st = 0, dx = 0, dragging = null;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { dragging = false; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); dx = 0; dragging = null;
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (dragging === false || e.touches.length !== 1) return;
      var mx = e.touches[0].clientX - sx, my = e.touches[0].clientY - sy;
      if (dragging === null) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        dragging = Math.abs(mx) > Math.abs(my) * 1.2;
        if (!dragging) return;
      }
      e.preventDefault();
      dx = mx;
      img.style.transition = 'none';
      img.style.transform = 'translateX(' + dx + 'px)';
      img.style.opacity = String(1 - Math.min(Math.abs(dx) / 500, 0.45));
    }, { passive: false });
    var end = function () {
      if (!dragging) { dragging = null; return; }
      dragging = null;
      var v = Math.abs(dx) / Math.max(Date.now() - st, 1);
      if (Math.abs(dx) > 70 || (Math.abs(dx) > 30 && v > 0.45)) { go(dx < 0 ? 'next' : 'prev', true); return; }
      img.style.transition = 'transform 260ms cubic-bezier(.2,.7,.2,1), opacity 260ms ease';
      img.style.transform = '';
      img.style.opacity = '';
    };
    stage.addEventListener('touchend', end);
    stage.addEventListener('touchcancel', end);
  }

  // coming back with the back button: put the photo back where it belongs
  window.addEventListener('pageshow', function () {
    if (img) { img.style.transition = 'none'; img.style.transform = ''; img.style.opacity = ''; }
  });

  // warm the next and previous photos so they appear instantly
  ['data-next-img', 'data-prev-img'].forEach(function (a) {
    var u = nav.getAttribute(a);
    if (u) { var i = new Image(); i.src = u; }
  });

  // arriving from (Prev)/(Next)/swipe: re-apply the format and size the buyer had chosen
  document.addEventListener('DOMContentLoaded', function () {
    var sel = null;
    try { sel = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (e) {}
    if (!sel || !sel.length) return;
    sel.forEach(function (val, i) {
      var b = Array.prototype.find.call(document.querySelectorAll('[data-opt="' + i + '"]'), function (x) { return x.getAttribute('data-val') === val; });
      if (b && !b.hidden && b.getAttribute('aria-pressed') !== 'true') b.click();
    });
  });
})();
